import { supabase } from "../../config/supabase";

 // Create a challenge
 const createMission = async (title = '') => {
    const newMission = { 
        title:title.toLowerCase()
    };
    try {
        const { error } = await supabase.from('missions').insert([newMission]);
        if (error) throw new Error(error);
        return { error: null };
    } catch (err) {
        console.log('an error in creating missions:',err);
        return { error: err };
    }
};

export { createMission };